import { render, staticRenderFns } from "./TermsOfUseModal.vue?vue&type=template&id=70ffb19e&scoped=true"
import script from "./TermsOfUseModal.vue?vue&type=script&lang=js"
export * from "./TermsOfUseModal.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUseModal.vue?vue&type=style&index=0&id=70ffb19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ffb19e",
  null
  
)

export default component.exports